var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{style:({
    height: _vm.stlye.height,
    width: _vm.stlye.width,
  })},[_c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }